"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseBackgroundImage;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function parseBackgroundImage(backgroundImage) {
  if ((0, _isEmpty["default"])(backgroundImage)) return;
  var parsedBackgroundImage = {};
  Object.keys(backgroundImage).forEach(function (breakpoint) {
    var _backgroundImage$brea;
    if ((_backgroundImage$brea = backgroundImage[breakpoint]) !== null && _backgroundImage$brea !== void 0 && _backgroundImage$brea.src) {
      var backgroundImageBreakpoint = backgroundImage[breakpoint];
      parsedBackgroundImage[breakpoint] = {
        src: backgroundImageBreakpoint.src,
        size: 'auto, 100%'
      };
    }
  });
  return parsedBackgroundImage;
}
//# sourceMappingURL=parseBackgroundImage.js.map